<template>
  <div class="wrapper">
    <div class="list">
      <div class="list__item" v-for="(item, index) in data"
           :key="item.name"
           :class="{'list__item_accent': hasHeader && index === 0}">
        <div class="list__item_name-wrapper">
          <span class="list__item-color" :style="{'background': allColors[index]}"></span>
          <span class="list__item-name"
                :title="item.name">{{item.name}}</span>
          <button style="margin-left: 15px;"
                  :style="{'background-color': index === editorIndex ? 'red' : 'rgb(133, 133, 133)'}"
                  @click.prevent="openEditor(index)">toogle color editor</button>
        </div>
        <div class="list__item-intermediate">
          <span>{{item.intermediate}}</span>
        </div>
        <div class="list__item-number">
          <span>{{item.value | roundNumber | commaDividedNumber}}</span>
        </div>
      </div>
      <temsplate v-if="footerItem">
        <div class="list__item list__item-footer"
             :class="{'list__item-footer_borderless': isFooterBorderless}">
          <div class="list__item-footer-name">
            {{footerItem.name}}
          </div>
          <div class="list__item-footer-value">
            <span>{{footerItem.value | roundNumber | commaDividedNumber}}</span>
          </div>
        </div>
      </temsplate>
    </div>
    <BasePieChart :list="data" :allColors="allColors" class="pie-chart"></BasePieChart>
    <ColorPicker v-if="Number.isInteger(editorIndex)"
                 class="list__color-picker"
                 :color="allColors[editorIndex]"
                 @color-change="updateColor">
      <template #alpha-range-input-label>
      </template>
      <template #copy-button>
        <span class="sr-only">Copy color</span>

        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="15"
          viewBox="0 0 15 15"
        >
          <path
            d="M5 0v2H1v13h12v-3h-1v2H2V5h10v3h1V2H9V0zm1 1h2v2h3v1H3V3h3z"
            fill="currentColor"
          />

          <path
            d="M10 7v2h5v2h-5v2l-3-3zM3 6h5v1H3zm0 2h3v1H3zm0 2h3v1H3zm0 2h5v1H3z"
            fill="currentColor"
          />
        </svg>
      </template>

    </ColorPicker>
  </div>
</template>

<script>
import _ from 'lodash'
import filters from '@/common/Filters'
import { mapActions } from 'vuex'
import { moveOtherToEnd } from '@/features/reports/common/Helper'
import { ColorPicker } from 'vue-accessible-color-picker'
export default {
  name: 'ColorPieChart',
  components: { ColorPicker },
  data () {
    return {
      allColors: [
        '#A80874', '#50D166', '#1E2EDE', '#E58C8A',
        '#E4572E', '#EEE82C', '#B24C63', '#4D9DE0',
        '#140D4F', '#F4FF52', '#84DD63', '#4E0250',
        '#EE6055'
      ],
      data: [],
      editorIndex: null,
      hasHeader: false,
      footerItem: ''
    }
  },
  watch: {
    clientId: {
      handler (v) {
        v && this.loadPageData()
      },
      immediate: true
    }
  },
  computed: {
    charData () {
      return this.handlePropsData()
    },
    isFooterBorderless () {
      return (this.hasHeader && this.data.length === 1) ||
        (!this.hasHeader && this.data.length === 0)
    }
  },
  methods: {
    ...mapActions('rankZoneOverview', [
      'getOverviewData'
    ]),
    updateColor (color) {
      const allColors = [...this.allColors]
      allColors[this.editorIndex] = color.colors.hex.length === 9 ? color.colors.hex.slice(0, -2) : color.colors.hex
      this.$set(this, 'allColors', allColors)
    },
    async loadPageData () {
      const data = await this.getOverviewData(this.clientId)
      const sectionsData = this.formatPieChartData(data.sections)
      this.data = sectionsData.items
      this.footerItem = sectionsData.footer
    },
    formatPieChartData (source) {
      const { total_msv, ...body } = source
      const keys = Object.keys(body)
      let items = keys.map(key => {
        return {
          name: key,
          value: body[key]
        }
      })

      items = _.orderBy(items, ['name'], ['asc'])
      items = moveOtherToEnd(items)
      return {
        items,
        footer: {
          name: 'Total MSV:',
          value: total_msv
        }
      }
    },
    handlePropsData () {
      let clonedData = _.cloneDeep(this.data)
      return clonedData
    },
    openEditor (index) {
      this.editorIndex = index === this.editorIndex ? null : index
    }
  },
  filters: {
    roundNumber: filters.roundNumber,
    commaDividedNumber: filters.commaDividedNumber
  }

}
</script>

<style scoped lang="scss">

  .wrapper {
    display: flex;
    width: 100%;
  }

  .list {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &__color-picker {
      position: absolute;
      left: 510px;
      z-index: 999999;
    }

    &__item {
      display: flex;
      justify-content: space-between;
      height: 30px;
      align-items: center;
      font-size: 12px;
      font-weight: 500;
      color: $rfx-silver;

      &-color {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        display: inline-block;
        margin: 0 10px 1px 0;
        flex-shrink: 0;
      }

      &-number {
        flex: 0 0 70px;
        display: flex;
        justify-content: flex-end;
        padding-left: 15px;
      }

      &-intermediate {
        flex: 0 0 30px;
        text-align: right;
      }

      &-name {
        font-size: 12px;
        font-weight: 500;
        @include ellipsis
      }

      &_name-wrapper {
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        flex: 1 1;
        padding-right: 15px;
      }

      &_accent {
        border-bottom: 1px solid $rfx-light-steel;

        div:not(.list__item-intermediate) span {
          font-weight: bold;
        }

        span {
          color: $rfx-steel;
        }
      }

      &-footer {
        border-top: 1px solid $rfx-light-steel;
        font-weight: 600;
        color: $rfx-steel;

        &_borderless {
          border: none;
        }

        &-name {
          flex: 1 1;
          text-align: right;
        }

        &-value {
          padding-left: 15px;
          flex: 0 0 70px;
          text-align: right;
        }
      }
    }

    &__total {
      display: flex;
      justify-content: flex-end;
      color: $rfx-dark-grey;
      border-top: 1px solid $rfx-light-steel;
      height: 30px;
      align-items: center;
      font-size: 12px;
      font-weight: bold;
    }
  }

  .pie-chart {
    width: 50%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  .sr-only {
    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
    white-space: nowrap;
  }
</style>
